import React from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import InlineEditCell from "./InlineEditCell";

export default function StockCell({ product, onSaved, suffix = "", testId, className = "" }) {
  const commit = async (n) => {
    const r = await api.put(`/products/${product.id}/stock`, { mode: "set", value: n });
    toast.success(`Stok ${product.name}: ${r.data.stock_available}`);
    onSaved?.(r.data.stock_available);
  };
  return (
    <InlineEditCell value={product.stock_available ?? 0} display={`${product.stock_available ?? 0}${suffix}`} onCommit={commit}
      invalidMsg="Stok harus angka 0 atau lebih" testId={testId} className={className}
      title="Klik untuk ubah stok, Enter untuk simpan" />
  );
}
